export default __webpack_public_path__ + "static/media/CustomerCase21.d88be99c.png";